// extracted by mini-css-extract-plugin
export default {"baseInput":"search-input_baseInput__Tit6Y","inputWrapper":"search-input_inputWrapper__8biJW"};